import { Spacing3, Spacing5 } from "@chemaxon/design-system/spacing";
import { TextField } from "@chemaxon/design-system/textfield";
import KeyboardArrowDown from "@chemaxon/design-system/icons/KeyboardArrowDown";
import { TeamMember } from "@chemaxon/terminus-client/ui/models/TeamMember";
import React, { useState } from "react";
import { Autocomplete } from "@mui/material";
import { Border } from "@chemaxon/design-system/color";
import GroupMembersContainer from "@chemaxon/terminus-client/ui/components/groups/GroupMembersContainer";

export default function GroupMemberSelector(props: Props) {
  const [groupMemberIds, setGroupMemberIds] = useState<number[]>(
    props.groupMemberIds,
  );

  const addToGroup = (memberId: number) => {
    setGroupMemberIds(groupMemberIds => [...groupMemberIds, memberId]);
    props.onAdd(memberId);
  };

  return (
    <>
      <Autocomplete
        id="teamMemberSelector"
        options={props.teamMembers
          .filter(tm => !groupMemberIds.includes(tm.id))
          .map(tm => ({ value: tm.id, label: tm.userName }))}
        onChange={(_, value) => addToGroup(value.value)}
        popupIcon={<KeyboardArrowDown />}
        disableClearable
        renderInput={params => (
          <TextField
            {...params}
            label="Add members to the group"
            placeholder="Type to search"
            size={"medium"}
            InputProps={{
              ...params.InputProps,
              sx: {
                border: "1px solid",
                borderColor: Border.default.main,
                borderRadius: 1,
                padding: `${Spacing3} ${Spacing3} ${Spacing3} ${Spacing5}`,
              },
            }}
            error={Boolean(props.error)}
            helperText={props.helperText}
          />
        )}
        renderTags={() => null}
      />
      {
        <GroupMembersContainer
          groupMemberIds={props.groupMemberIds}
          setGroupMemberIds={setGroupMemberIds}
          teamMembers={props.teamMembers}
          onRemove={props.onRemove}
          disabled={props.scim}
        />
      }
    </>
  );
}

type Props = {
  groupMemberIds: number[];
  teamMembers: TeamMember[];
  onAdd: (value: number) => void;
  onRemove: (value: number) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  scim: boolean;
};
